// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__small[data-v-438fb726]{font-size:9px;font-weight:400;line-height:1.56;letter-spacing:.18px}.text__small.bold[data-v-438fb726]{font-weight:700}", ""]);
// Exports
module.exports = exports;
